import React, { Component } from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import chinaMap from '../../assets/chinaMap.png'

import Content from '../../components/Content'
import { Container } from 'react-bootstrap'

import Form from '../../components/Form'

export default class Tours extends Component {
  render() {
    return (
      <Container>
        <div style={{ marginTop: 50 }}></div>
        <Row style={{ zIndex: 2, position: 'relative' }}>
          <Col lg={8} sm={5}>
            <Content className="animated fadeInLeft" />
          </Col>
          <Col lg={4} sm={7}>
            <div
              style={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                margin: '0 auto',
              }}>
              <Form subject="Интересное" />
            </div>
          </Col>
        </Row>
        <Map src={chinaMap} className="animated fadeInUp" />
      </Container>
    )
  }
}

const Map = styled.img`
  width: 60vw;
  max-width: 1000px;
  position: fixed;
  bottom: 0px;
  z-index: 1;
  left: 10vw;
  margin-top: auto;

  @media (max-width: 768px) {
    display: none;
  }
`
